import { useState } from "react";
import { Mail, Loader2, Check } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function NewsletterForm({ dark = false }) {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [status, setStatus] = useState({ state: "idle", msg: "" });

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", msg: "" });
    try {
      const { data } = await api.post("/newsletter/subscribe", {
        email,
        first_name: firstName,
      });
      const mc = data.mailchimp || {};
      const msg = mc.configured
        ? "You're subscribed to the Ecosystem Digest."
        : "You're on the list! (Digest delivery activates once Mailchimp is connected.)";
      setStatus({ state: "done", msg });
      setEmail("");
      setFirstName("");
    } catch (err) {
      setStatus({ state: "error", msg: formatApiError(err.response?.data?.detail) });
    }
  };

  const textCls = dark ? "text-white" : "text-[#1A242B]";
  const subCls = dark ? "text-white/70" : "text-[#4A5D6B]";

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="w-full max-w-md">
      <p className="eyw-label mb-2" style={dark ? { color: "#D98E73" } : undefined}>
        Weekly Ecosystem Digest
      </p>
      <h3 className={`text-2xl mb-2 ${textCls}`}>Stay woven into the ecosystem.</h3>
      <p className={`text-sm mb-5 ${subCls}`}>
        Fresh articles, upcoming gatherings, and a note from the community — once a week.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          data-testid="newsletter-name-input"
          type="text"
          placeholder="First name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          className="flex-1 rounded-full border border-[#E5E0D8] bg-white px-5 py-3 text-sm text-[#1A242B] outline-none focus:border-[#144F75]"
        />
        <input
          data-testid="newsletter-email-input"
          type="email"
          required
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-[1.5] rounded-full border border-[#E5E0D8] bg-white px-5 py-3 text-sm text-[#1A242B] outline-none focus:border-[#144F75]"
        />
      </div>
      <button
        data-testid="newsletter-submit-btn"
        type="submit"
        disabled={status.state === "loading"}
        className="eyw-btn mt-4 w-full sm:w-auto disabled:opacity-60"
      >
        {status.state === "loading" ? (
          <Loader2 className="animate-spin" size={18} />
        ) : status.state === "done" ? (
          <Check size={18} />
        ) : (
          <Mail size={18} />
        )}
        {status.state === "done" ? "Subscribed" : "Join the Digest"}
      </button>
      {status.msg && (
        <p
          data-testid="newsletter-message"
          className={`mt-3 text-sm ${status.state === "error" ? "text-red-600" : dark ? "text-[#8FA89B]" : "text-[#144F75]"}`}
        >
          {status.msg}
        </p>
      )}
    </form>
  );
}
